/**
 * Simple wishlist lookup helpers.
 * All state lives in window.swymWishLists, populated once by useSwymInit,
 * cards subscribe to WISHLIST_UPDATED_EVENT for reactive updates.
 */
export const WISHLIST_UPDATED_EVENT = "birdsnest:wishlist-updated";
export const isProductInWishlist = (empi) => {
    if (!window.swymWishLists)
        return false;
    const id = String(empi);
    return window.swymWishLists.some((list) => { var _a; return (_a = list.listcontents) === null || _a === void 0 ? void 0 : _a.some((item) => String(item.empi) === id); });
};
export const isVariantInWishlist = (empi, epi) => {
    if (!window.swymWishLists)
        return false;
    const empiStr = String(empi);
    const epiStr = String(epi);
    return window.swymWishLists.some((list) => {
        var _a;
        return (_a = list.listcontents) === null || _a === void 0 ? void 0 : _a.some((item) => String(item.empi) === empiStr && String(item.epi) === epiStr);
    });
};
